import { Link } from 'react-router-dom';
import { NAV } from '@/constants/testIds';

/**
 * AutoMarket Colombia — brand mark.
 *
 * Renders the official logo (transparent PNG). Kept as a small component so
 * every page uses the same asset + testid + accessibility label.
 *
 * Props:
 *   variant='light' (default) → straight over a light background, no chrome.
 *   variant='dark'            → wrapped in a subtle white card so the dark
 *                               navy/red inks stay legible on the footer.
 *   size='sm' | 'md' | 'lg'   → drives the rendered height (width auto).
 */
const LOGO_SRC = '/brand-logo.png';

const HEIGHT = {
  sm: 'h-9 sm:h-11',
  md: 'h-12 sm:h-16',
  lg: 'h-16 sm:h-20',
};

export const Logo = ({ to = '/', variant = 'light', size = 'md', className = '' }) => {
  const h = HEIGHT[size] || HEIGHT.md;
  const img = (
    <img
      src={LOGO_SRC}
      alt="AutoMarket Colombia · Repuestos originales, confianza que te mueve"
      className={`${h} w-auto object-contain select-none`}
      draggable={false}
    />
  );

  return (
    <Link
      to={to}
      data-testid={NAV.logo}
      aria-label="AutoMarket Colombia · Ir al inicio"
      className={`inline-flex items-center shrink-0 group transition-transform duration-300 hover:-rotate-1 ${className}`}
    >
      {variant === 'dark' ? (
        <span className="inline-flex items-center rounded-md bg-white px-3 py-2 shadow-sm ring-1 ring-black/5">
          {img}
        </span>
      ) : (
        img
      )}
    </Link>
  );
};
